import React from 'react';
import { Box, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useRecoilState } from 'recoil';
import { announcementPreview } from 'store';
import FreezeBanner from 'components/FreezeBanner';

const PreviewBanner = () => {
    const [preview, setPreview] = useRecoilState(announcementPreview);

    // Auto-dismiss preview banner after 10 seconds
    React.useEffect(() => {
        if (preview) {
            const timer = setTimeout(() => setPreview(null), 10000);
            return () => clearTimeout(timer);
        }
        return undefined;
    }, [preview]);

    if (!preview) return null;

    return (
        <Box sx={{ position: 'relative' }}>
            <FreezeBanner severity={preview?.severity} message={preview?.message} />
            <IconButton
                onClick={() => setPreview(null)}
                sx={{
                    position: 'absolute',
                    top: 4,
                    right: 8,
                    color: 'inherit',
                    background: 'rgba(255,255,255,0.3)',
                    '&:hover': { background: 'rgba(255,255,255,0.5)' },
                }}
                size="small"
                data-testid="preview-banner-close"
            >
                <CloseIcon fontSize="small" />
            </IconButton>
        </Box>
    );
};

export default PreviewBanner;
